module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Border-cc853f4065ac4f8672d83361f23540c5.svg";